import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import i18next from 'i18next';
import styled from 'styled-components';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import config from '../../config';
import {
  uBold,
  uFlexColumn,
  uTextAlignCenter,
} from '../../assets/styles/utility';
import themeColors from '../../assets/styles/themeColors';
import { pxToRem } from '../../assets/styles/helper';

export const TermsAndPrivacyWrapper = styled.div`
  ${uFlexColumn}
  align-items:center;
  justify-content: center;
  border-top: 1px solid ${themeColors.colorBorderSemiDark};
  padding: ${pxToRem(16)};
  margin-top: auto;
`;

export const TermsAndPrivacyText = styled.p`
  ${uTextAlignCenter}
  color:${themeColors.colorTextXLLight};

  &:not(&:last-of-type) {
    margin-bottom: ${pxToRem(12)};
  }

  > a {
    text-decoration: underline;
    color: ${themeColors.colorLink};
    ${uBold};
  }
`;

const TermsAndPrivacy = ({ marginTop }) => {
  const settings = useSelector(selectSettings);
  const brokerName = settings?.BrokerName;
  const { metalStreamCaption } = config;
  const location = useLocation();

  return (
    <TermsAndPrivacyWrapper mt={marginTop}>
      {location.pathname === '/ira-funding' && (
        <TermsAndPrivacyText>
          {
            (i18next.t('registration.metalStreamCopy'),
            {
              metalStream: metalStreamCaption,
            })
          }
        </TermsAndPrivacyText>
      )}

      <TermsAndPrivacyText>
        {i18next.t('termsAndPrivacy.text', { brokerName })}{' '}
        <a
          href={settings.TermsAndConditionsUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {i18next.t('termsAndPrivacy.terms')}
        </a>{' '}
        {i18next.t('termsAndPrivacy.and')}{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={settings.PrivacyPolicyDocumentUrl}
        >
          {i18next.t('termsAndPrivacy.privacy')}
        </a>
        .
      </TermsAndPrivacyText>
    </TermsAndPrivacyWrapper>
  );
};

TermsAndPrivacy.propTypes = {
  marginTop: PropTypes.number,
};

export default TermsAndPrivacy;
